<template>
  <div v-if="profile && profile.userId ">
    <block-shelf-resources
        v-if="hasSeenWelcomeForm"
        :viewing-id="profile.userId"
        :apps="apps"
        :display-app-icons="true"
    />
    <type-form
        v-else
        :form-data="formData"
        :lottie="lottie"
        @complete="handleFormComplete"
    />
    <!------ WELCOME|INTRO}ABOUT LAYER ---->
    <onboard-welcome
        :id="onboardWelcomeId"
        :onboard-model="!hasSeenWelcomeModal"
        :position="onboardWelcomePos"
        :profile="profile"
        @start-click="handleWelcomeModalSeen"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlockShelfResources from "@/components/blockShelfResources";
import OnboardWelcome from "@/components/modals/onboardWelcome";
import TypeForm from "@/components/typeForm";
import formData from "@/assets/forms/onboard-info";
export default {
  name: "myApps",
  components: {
    BlockShelfResources,
    OnboardWelcome,
    TypeForm
  },
  created() {},
  mounted() {
    this.getApps();
  },
  props: {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      apps: "user/apps",
      appSettings: "user/appsSettings",
      settingsUser: "tools/settingsUser",
      settingsGen: "tools/settingsGen"
    }),
    hasSeenWelcomeModal(){
      return  this.profile && this.profile.seen && this.profile.seen.modal && this.profile.seen.modal.welcome ? true : false;
    },
    hasSeenWelcomeForm(){
      return this.profile && this.profile.seen && this.profile.seen.form && this.profile.seen.form[this.formData.formId] ? true : false;
    },
  },
  methods: {
    getProfile() {
      this.$store.dispatch("user/getProfile", "").then(res => {

      });
    },
    getApps() {
      this.$store.dispatch("user/getListApps").then(apps => {});
    },
    handleWelcomeModalSeen(){
      const payload = {
        type:'modal',
        id:'welcome'
      };

      this.$store.dispatch("user/updateSeen", payload)
          .then(resp => {
            this.getProfile();  //@ToDo - decide if better to do this after form complete
          })
          .catch(err =>{});
    },
    handleFormComplete(dataFromForm) {
      const payload = {
        type:'form',
        id: dataFromForm.formId
      };

      this.$store.dispatch("user/updateSeen", payload)
          .then(resp => {
            this.getProfile();  //@ToDo - decide if better to do this after form complete
          })
          .catch(err =>{

          });
    }
  },
  data() {
    return {
      formData,
      onboardWelcomeId: "onboard-welcome",
      onboardWelcomePos: 1,
      lottie: {
        src: "assets/lotties/blog-management.json",
        alt: "Standard"
      }
    };
  }
};
</script>

<style lang="css" scoped>

</style>
